export default "__VITE_ASSET__DiENyb5g__"